"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "createProduct",
  data: function data() {
    return {
      dialogVisible: false,
      startTimeList: [{
        start: '',
        end: '',
        time: [],
        group: 1
      }, {
        start: '',
        end: '',
        time: [],
        group: 2
      }, {
        start: '',
        end: '',
        time: [],
        group: 3
      }],
      formValidate: {
        profit_status: 1,
        id: null,
        fkzxbdz: "",
        fkzdbdz: "",
        sjbdfw: "",
        mode_type: 1,
        open_time: "",
        remark: ""
      },
      time_scheme_list: [],
      // 时间玩法设置
      timeModeList: [],
      // 金额玩法设置时间参数
      modeList: [],
      // 金额玩法设置金额列表
      myHeaders: {
        "X-Token": (0, _auth.getToken)()
      },
      loading: false,
      languarList: []
    };
  },
  mounted: function mounted() {},
  methods: {
    addMode: function addMode(list) {
      // 添加金额模式
      if (list == 'timeModeList') {
        this.timeModeList.push({
          time: "",
          min_invest_money: "",
          max_invest_money: ""
        });
      }
      if (list == 'time_scheme_list') {
        this.time_scheme_list.push({
          time: "",
          min_invest_money: "",
          max_invest_money: "",
          profit_rate: "",
          loss_rate: ""
        });
      }
      if (list == 'modeList') {
        this.modeList.push({
          min_invest_money: "",
          max_invest_money: "",
          profit_rate: "",
          loss_rate: ""
        });
      }
    },
    handleDelete: function handleDelete(index, list) {
      this[list].splice(index, 1);
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs.user.validate(function (valid) {
        if (valid) {
          if (_this.formValidate.mode_type == 1 && _this.time_scheme_list.length < 1) {
            _this.$message.warning(_this.$t('qzstjyzwf'));
            return false;
          }
          if (_this.formValidate.mode_type == 2 && _this.modeList.length < 1) {
            _this.$message.warning(_this.$t('qzstjyzwf'));
            return false;
          }
          if (_this.startTimeList.length < 1) {
            _this.$message.warning(_this.$t('qzstjytsj'));
            return false;
          }
          var list = [];
          _this.startTimeList.filter(function (item) {
            return item.time.length;
          }).forEach(function (item, index) {
            var timeList = item.time.map(function (sunItem) {
              return {
                time: sunItem,
                start: item.start,
                end: item.end,
                group: item.group
              };
            });
            list.push.apply(list, _toConsumableArray(timeList));
          });
          _this.loading = true;
          var data = _objectSpread(_objectSpread({}, _this.formValidate), {}, {
            start_time_list: list,
            time_scheme_list: _this.formValidate.mode_type == 1 ? _this.time_scheme_list : _this.timeModeList.map(function (item) {
              var time = item.time,
                min_invest_money = item.min_invest_money,
                max_invest_money = item.max_invest_money,
                id = item.id,
                product_id = item.product_id;
              return {
                time: time,
                min_invest_money: min_invest_money,
                max_invest_money: max_invest_money,
                id: id,
                product_id: product_id
              };
            }),
            money_scheme_list: _this.modeList,
            id_list: JSON.parse(sessionStorage.getItem('editDate')).map(function (item) {
              return item.id;
            })
          });
          (0, _product.saveBatchProduct)(data).then(function (res) {
            _this.$message.success(_this.$t('xgcg'));
            _this.loading = false;
            window.history.go(-1);
          }).catch(function () {
            _this.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this[formName] = {};
      window.history.go(-1);
    }
  }
};
exports.default = _default;